var map = {
	"./animal_quiz/game": [
		"a77d",
		"chunk-2d208e79"
	],
	"./animal_quiz/game/": [
		"a77d",
		"chunk-2d208e79"
	],
	"./animal_quiz/game/Game": [
		"765e"
	],
	"./animal_quiz/game/Game.vue": [
		"765e"
	],
	"./animal_quiz/game/__tests__/AnimalQuizGame.spec": [
		"d64f",
		"chunk-2d0c8067",
		"chunk-36e549b0"
	],
	"./animal_quiz/game/__tests__/AnimalQuizGame.spec.js": [
		"d64f",
		"chunk-2d0c8067",
		"chunk-36e549b0"
	],
	"./animal_quiz/game/index": [
		"a77d",
		"chunk-2d208e79"
	],
	"./animal_quiz/game/index.js": [
		"a77d",
		"chunk-2d208e79"
	],
	"./animal_quiz/highscore": [
		"d0df",
		"chunk-2d21d6c4"
	],
	"./animal_quiz/highscore/": [
		"d0df",
		"chunk-2d21d6c4"
	],
	"./animal_quiz/highscore/Highscore": [
		"e944"
	],
	"./animal_quiz/highscore/Highscore.vue": [
		"e944"
	],
	"./animal_quiz/highscore/__tests__/AnimalQuizHighscore.spec": [
		"cae1",
		"chunk-2d0c8067",
		"chunk-ee858726"
	],
	"./animal_quiz/highscore/__tests__/AnimalQuizHighscore.spec.js": [
		"cae1",
		"chunk-2d0c8067",
		"chunk-ee858726"
	],
	"./animal_quiz/highscore/index": [
		"d0df",
		"chunk-2d21d6c4"
	],
	"./animal_quiz/highscore/index.js": [
		"d0df",
		"chunk-2d21d6c4"
	],
	"./animal_quiz/start": [
		"c19e",
		"chunk-2d2160f0"
	],
	"./animal_quiz/start/": [
		"c19e",
		"chunk-2d2160f0"
	],
	"./animal_quiz/start/Start": [
		"4e80"
	],
	"./animal_quiz/start/Start.vue": [
		"4e80"
	],
	"./animal_quiz/start/__tests__/AnimalQuizStart.spec": [
		"8835",
		"chunk-2d0c8067",
		"chunk-9fec7cfe"
	],
	"./animal_quiz/start/__tests__/AnimalQuizStart.spec.js": [
		"8835",
		"chunk-2d0c8067",
		"chunk-9fec7cfe"
	],
	"./animal_quiz/start/index": [
		"c19e",
		"chunk-2d2160f0"
	],
	"./animal_quiz/start/index.js": [
		"c19e",
		"chunk-2d2160f0"
	],
	"./animal_sounds/start": [
		"1d3b",
		"chunk-2d0b6518"
	],
	"./animal_sounds/start/": [
		"1d3b",
		"chunk-2d0b6518"
	],
	"./animal_sounds/start/AnimalSoundsStart": [
		"691e"
	],
	"./animal_sounds/start/AnimalSoundsStart.vue": [
		"691e"
	],
	"./animal_sounds/start/__tests__/AnimalSoundsStart.spec": [
		"71ef",
		"chunk-2d0c8067",
		"chunk-25c7b4a0"
	],
	"./animal_sounds/start/__tests__/AnimalSoundsStart.spec.js": [
		"71ef",
		"chunk-2d0c8067",
		"chunk-25c7b4a0"
	],
	"./animal_sounds/start/index": [
		"1d3b",
		"chunk-2d0b6518"
	],
	"./animal_sounds/start/index.js": [
		"1d3b",
		"chunk-2d0b6518"
	],
	"./animals_in_order/game": [
		"0e57",
		"chunk-2d0af48d"
	],
	"./animals_in_order/game/": [
		"0e57",
		"chunk-2d0af48d"
	],
	"./animals_in_order/game/Game": [
		"57e5"
	],
	"./animals_in_order/game/Game.vue": [
		"57e5"
	],
	"./animals_in_order/game/__tests__/AnimalsInOrderGame.spec": [
		"4005",
		"chunk-2d0c8067",
		"chunk-fdb4ff42"
	],
	"./animals_in_order/game/__tests__/AnimalsInOrderGame.spec.js": [
		"4005",
		"chunk-2d0c8067",
		"chunk-fdb4ff42"
	],
	"./animals_in_order/game/index": [
		"0e57",
		"chunk-2d0af48d"
	],
	"./animals_in_order/game/index.js": [
		"0e57",
		"chunk-2d0af48d"
	],
	"./animals_in_order/highscore": [
		"e124",
		"chunk-2d2248a4"
	],
	"./animals_in_order/highscore/": [
		"e124",
		"chunk-2d2248a4"
	],
	"./animals_in_order/highscore/Highscore": [
		"966e"
	],
	"./animals_in_order/highscore/Highscore.vue": [
		"966e"
	],
	"./animals_in_order/highscore/__tests__/AnimalsInOrderHighscore.spec": [
		"6c26",
		"chunk-2d0c8067",
		"chunk-71ba1bf4"
	],
	"./animals_in_order/highscore/__tests__/AnimalsInOrderHighscore.spec.js": [
		"6c26",
		"chunk-2d0c8067",
		"chunk-71ba1bf4"
	],
	"./animals_in_order/highscore/index": [
		"e124",
		"chunk-2d2248a4"
	],
	"./animals_in_order/highscore/index.js": [
		"e124",
		"chunk-2d2248a4"
	],
	"./animals_in_order/start": [
		"74e4",
		"chunk-2d0d7102"
	],
	"./animals_in_order/start/": [
		"74e4",
		"chunk-2d0d7102"
	],
	"./animals_in_order/start/Start": [
		"2e3a"
	],
	"./animals_in_order/start/Start.vue": [
		"2e3a"
	],
	"./animals_in_order/start/__tests__/AnimalsInOrderStart.spec": [
		"5e13",
		"chunk-2d0c8067",
		"chunk-6ef17ffa"
	],
	"./animals_in_order/start/__tests__/AnimalsInOrderStart.spec.js": [
		"5e13",
		"chunk-2d0c8067",
		"chunk-6ef17ffa"
	],
	"./animals_in_order/start/index": [
		"74e4",
		"chunk-2d0d7102"
	],
	"./animals_in_order/start/index.js": [
		"74e4",
		"chunk-2d0d7102"
	],
	"./animals_in_order_blind/game": [
		"19eb",
		"chunk-2d0ac9bb"
	],
	"./animals_in_order_blind/game/": [
		"19eb",
		"chunk-2d0ac9bb"
	],
	"./animals_in_order_blind/game/Game": [
		"e878"
	],
	"./animals_in_order_blind/game/Game.vue": [
		"e878"
	],
	"./animals_in_order_blind/game/__tests__/AnimalsInOrderBlindGame.spec": [
		"7c40",
		"chunk-2d0c8067",
		"chunk-8a417634"
	],
	"./animals_in_order_blind/game/__tests__/AnimalsInOrderBlindGame.spec.js": [
		"7c40",
		"chunk-2d0c8067",
		"chunk-8a417634"
	],
	"./animals_in_order_blind/game/index": [
		"19eb",
		"chunk-2d0ac9bb"
	],
	"./animals_in_order_blind/game/index.js": [
		"19eb",
		"chunk-2d0ac9bb"
	],
	"./animals_in_order_blind/highscore": [
		"b151",
		"chunk-2d20ebe1"
	],
	"./animals_in_order_blind/highscore/": [
		"b151",
		"chunk-2d20ebe1"
	],
	"./animals_in_order_blind/highscore/Highscore": [
		"ae45"
	],
	"./animals_in_order_blind/highscore/Highscore.vue": [
		"ae45"
	],
	"./animals_in_order_blind/highscore/__tests__/AnimalsInOrderBlindHighscore.spec": [
		"ecb1",
		"chunk-2d0c8067",
		"chunk-3b5650f2"
	],
	"./animals_in_order_blind/highscore/__tests__/AnimalsInOrderBlindHighscore.spec.js": [
		"ecb1",
		"chunk-2d0c8067",
		"chunk-3b5650f2"
	],
	"./animals_in_order_blind/highscore/index": [
		"b151",
		"chunk-2d20ebe1"
	],
	"./animals_in_order_blind/highscore/index.js": [
		"b151",
		"chunk-2d20ebe1"
	],
	"./animals_in_order_blind/start": [
		"ae35",
		"chunk-2d213a7c"
	],
	"./animals_in_order_blind/start/": [
		"ae35",
		"chunk-2d213a7c"
	],
	"./animals_in_order_blind/start/Start": [
		"36ca"
	],
	"./animals_in_order_blind/start/Start.vue": [
		"36ca"
	],
	"./animals_in_order_blind/start/__tests__/AnimalsInOrderBlindStart.spec": [
		"a8f8",
		"chunk-2d0c8067",
		"chunk-04088bf4"
	],
	"./animals_in_order_blind/start/__tests__/AnimalsInOrderBlindStart.spec.js": [
		"a8f8",
		"chunk-2d0c8067",
		"chunk-04088bf4"
	],
	"./animals_in_order_blind/start/index": [
		"ae35",
		"chunk-2d213a7c"
	],
	"./animals_in_order_blind/start/index.js": [
		"ae35",
		"chunk-2d213a7c"
	],
	"./home": [
		"e04b",
		"chunk-2d22454f"
	],
	"./home/": [
		"e04b",
		"chunk-2d22454f"
	],
	"./home/Home": [
		"5c28"
	],
	"./home/Home.vue": [
		"5c28"
	],
	"./home/__tests__/Home.spec": [
		"d17e",
		"chunk-2d0c8067",
		"chunk-7a270ac7"
	],
	"./home/__tests__/Home.spec.js": [
		"d17e",
		"chunk-2d0c8067",
		"chunk-7a270ac7"
	],
	"./home/index": [
		"e04b",
		"chunk-2d22454f"
	],
	"./home/index.js": [
		"e04b",
		"chunk-2d22454f"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a383";
module.exports = webpackAsyncContext;